var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-table", {
        staticClass: "sticky-header-table",
        attrs: {
          data: _vm.bundles,
          columns: _vm.columns,
          "visible-columns": _vm.visibleColumns,
          "rows-per-page-options": _vm.rowsPerPageOptions,
          pagination: _vm.pagination,
          loading: _vm.loading,
          selection: _vm.selection,
          selected: _vm.selected,
          "row-key": "intBundleId"
        },
        on: {
          "update:pagination": function($event) {
            _vm.pagination = $event
          },
          "update:selected": function($event) {
            _vm.selected = $event
          },
          selection: _vm.bundleSelection
        },
        scopedSlots: _vm._u(
          [
            _vm.showTitle
              ? {
                  key: "top-left",
                  fn: function() {
                    return [
                      _c("div", { staticClass: "q-table__title table-title" }, [
                        _c("p", [_vm._v(_vm._s(_vm.speciesName))]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.$t("veneerLog")) +
                              " " +
                              _vm._s(_vm.logNo)
                          )
                        ])
                      ])
                    ]
                  },
                  proxy: true
                }
              : null,
            _vm.allowDownload
              ? {
                  key: "top-right",
                  fn: function() {
                    return [
                      _c("q-btn", {
                        attrs: {
                          label: _vm.$t("button.download"),
                          color: "primary",
                          icon: "cloud_download",
                          "no-caps": "",
                          "no-wrap": ""
                        },
                        on: { click: _vm.downloadMeasurementList }
                      })
                    ]
                  },
                  proxy: true
                }
              : null,
            {
              key: "body-cell-originalLog",
              fn: function(cell) {
                return [
                  _c(
                    "q-td",
                    [
                      cell.value.link
                        ? _c(
                            "router-link",
                            {
                              attrs: { to: cell.value.link, target: "_blank" }
                            },
                            [_vm._v(_vm._s(cell.value.logNo))]
                          )
                        : [_vm._v("-")]
                    ],
                    2
                  )
                ]
              }
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }